import { CustomFieldTemplate } from "../CustomFields/CustomFieldTemplates";
import { PropertyTranslator, IRelatedEntityLabels, INamedEntityParametersTranslator } from "../GenericTranslator";
import {
  EntityConstants,
  GenericEntityOrderBy,
  IEntityMinimalModel,
  INamedEntity,
  IRelatedEntity,
  IRelation,
  IRelationModel,
  NamedEntityOrderBy,
} from "../GenericTypes";
import {
  CustomTypeBase,
  CustomTypeBaseFieldLabels,
  CustomTypeBaseFilters,
  CustomTypeBaseFiltersTranslator,
  CustomTypeBaseSection,
} from "./CustomTypesBase";
import { CustomTypeTemplatePackage } from "./CustomTypeTemplatePackages";

export const customTypeTemplateConstants: EntityConstants<CustomTypeTemplate, CustomTypeTemplateFilters> = {
  resource: "custom_type_templates",
  frontendIndexRoute: "custom_type_templates",
  entitySingular: "custom type template",
  entityPlural: "custom type templates",
  icon: "copy",
};

export interface CustomTypeTemplate extends CustomTypeBase, IRelatedEntity<CustomTypeTemplateRelations> {
  sections: CustomTypeTemplateSection[];
  templateVersion: string;
  customTypesFromCurrentTemplate?: IEntityMinimalModel[];
  customTypeTemplatePackages?: CustomTypeTemplatePackage[];
}

export const CustomTypeTemplateFieldLabels: PropertyTranslator<CustomTypeTemplate> = {
  ...CustomTypeBaseFieldLabels,
  ...IRelatedEntityLabels,
  sections: "Sections",
  templateVersion: "Template Version",
  customTypesFromCurrentTemplate: "Custom types using this template",
  customTypeTemplatePackages: "Custom type template packages",
} as const;

export interface CustomTypeTemplateSection extends CustomTypeBaseSection, INamedEntity {
  customFields: CustomFieldTemplate[];
}

export interface CustomTypeTemplateRelations extends IRelationModel {
  customTypes: IRelation;
}

export interface CustomTypeTemplateFilters extends CustomTypeBaseFilters<CustomTypeTemplateSortingOptions> {
  customFieldTemplateIds?: number[] | null;
  customTypeTemplatePackageIds?: number[] | null;
}

export const CustomTypeTemplateSortingOptionsConsts = [...GenericEntityOrderBy, ...NamedEntityOrderBy] as const;
export type CustomTypeTemplateSortingOptions = (typeof CustomTypeTemplateSortingOptionsConsts)[number];

export const CustomTypeTemplateFiltersTranslator: PropertyTranslator<CustomTypeTemplateFilters> = {
  ...CustomTypeBaseFiltersTranslator,
  ...INamedEntityParametersTranslator,
  customFieldTemplateIds: "Custom field template ID(s)",
  customTypeTemplatePackageIds: "Custom type template package ID(s)",
} as const;
